import i18n from 'i18n'
import ContentLoader from 'react-content-loader'
import { IContentLoaderProps } from 'react-content-loader'
import { theme } from 'theme'

const UserInfoLoader = (props: IContentLoaderProps) => {
  return (
    <ContentLoader
      height={76}
      width={'100%'}
      viewBox="0 0 300 76"
      backgroundColor={theme.palette.surface.subtle}
      foregroundColor={theme.palette.border.primary}
      style={{ transform: i18n.dir() === 'rtl' ? 'scaleX(-1)' : undefined }}
      {...props}
    >
      {/* Avatar circle */}
      <circle cx="32" cy="35" r="26" />

      {/* User name */}
      <rect x="75" y="8" rx="3" ry="3" width="140" height="16" />

      {/* Phone number / identifier */}
      <rect x="75" y="28" rx="3" ry="3" width="100" height="12" />

      {/* Tier/Purchase button */}
      <rect x="75" y="46" rx="12" ry="12" width="80" height="26" />
    </ContentLoader>
  )
}

export default UserInfoLoader
